import { createAsyncThunk } from '@reduxjs/toolkit';
import { StoreState } from '../../../store/store.interface';
import { OptinOutData } from '../interface/inclusive-access.interface';
import { getInclusiveAccessApiCall } from '../api/inclusive-access.apis';
import { isLoadingInclusiveAccess, isSucceededInclusiveAccess } from '../store/inclusive-access.selectors';

export const fetchInclusiveAccessData = createAsyncThunk(
  'inclusiveAccess/fetchInclusiveAccessData',
  async (_, thunkAPI) => {
    try {
      var inclusiveAccessData: OptinOutData[] = [];
      return inclusiveAccessData
        .concat(await getInclusiveAccessApiCall())
        .sort((a, b) => new Date(b.lastUpdatedDate).getTime() - new Date(a.lastUpdatedDate).getTime());
    } catch (error: any) {
      if (error.responseStatus === 404) {
        throw new Error('No data found');
      }

      // For other errors, reject with the error
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_data, { getState }) => {
      const state = getState() as StoreState;
      if (isLoadingInclusiveAccess(state) || isSucceededInclusiveAccess(state)) {
        return false;
      }
      return true;
    },
  }
);
